<script setup lang="ts">
import { defineModel } from "vue";

interface Props {
	name: string;
	valueA: string;
	valueB: string;
	labelA: string;
	labelB: string;
	idPrefix: string;
}

const props = defineProps<Props>();
const model = defineModel({ required: true });

const toggleValues = [{
	value: props.valueA,
	label: props.labelA,
}, {
	value: props.valueB,
	label: props.labelB,
}];

</script>
<template>
	<div class="text-toggle">
		<template v-for="item in toggleValues" :key="item.value">
			<input
				:id="idPrefix + '-' + item.value"
				:name="name"
				class="text-toggle__input"
				type="radio"
				v-model="model"
				:value="item.value"
				:checked="model === item.value"
			/>
			<label
				:class="{
					'text-toggle__label': true,
					'text-toggle__label--active': model === item.value,
				}"
				:for="idPrefix + '-' + item.value"
			>
				{{ item.label }}
			</label>
		</template>
	</div>
</template>
<style scoped lang="scss">
.text-toggle {
	@include font-size(11px, 23px);
	background: $measurements-toggle-bg;
	height: 23px;
	display: inline-block;
	border-radius: 12px;
	margin-top: 10px;
	cursor: pointer;
}

.text-toggle__input {
	opacity: 0;
	width: 0;
	height: 0;
	padding: 0;
}

.text-toggle__label {
	padding: 0 10px;
	height: 23px;
	display: inline-block;
	cursor: pointer;

	&--active {
		border-radius: 12px;
		background-color: $white;
		box-shadow: 0 0 6px 0 rgba($brand-blue-dark, 25%);
	}
}

.text-toggle__input:focus-visible + .text-toggle__label {
	outline: auto;
	outline-offset: 2px;
}
</style>
